import createSvgIcon from '../create-svg-icon';

export const MenuIcon = createSvgIcon(
  <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
, 'MenuOutlined');
